import React from "react";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { ReactComponent as LoginArrow } from "../../../assets/loginArrow.svg";

const AuthPopup: React.FC<{
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  title: string;
  description: string;
}> = ({ show, setShow, title, description }) => {
  const navigate = useNavigate();

  return (
    <Modal
      show={show}
      footer={null}
      onHide={() => {
        setShow(false);
      }}
      className="auth-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title className="title">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{description}</Modal.Body>
      <Modal.Footer>
        <button
          className="auth-btn"
          onClick={(e) => {
            e.preventDefault();
            setShow(false);
          }}
        >
          Cancel
        </button>
        <button
          className="auth-btn login-btn"
          onClick={(e) => {
            e.preventDefault();
            navigate("/login");
          }}
        >
          Log in <LoginArrow className="loginArrow" />
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default AuthPopup;
